<script lang="ts" setup>
import { ref, onMounted,onUnmounted, nextTick } from "vue";
import { TUICallKit, TUICallKitServer, STATUS, TUIGlobal } from "@tencentcloud/call-uikit-vue";
import DeviceDetector from "./components/DeviceDetector/index.vue";
import * as GenerateTestUserSig from "../public/debug/GenerateTestUserSig-es.js";
import TIM from "@tencentcloud/chat";
import copy from "copy-to-clipboard";
import videoBlackSVG from "./assets/videoBlack.svg";
import videoWhiteSVG from "./assets/videoWhite.svg";
import audioWhiteSVG from "./assets/audioWhite.svg";
import audioBlackSVG from "./assets/audioBlack.svg";
import searchSVG from "./assets/search.svg";
import cancelSVG from "./assets/cancel.svg";
import languageSVG from "./assets/language.svg";
import { ElMessage, ElLoading } from "element-plus";
import { getUrlParam , isWeixin} from "./utils";
import jweixin from "weixin-js-sdk";
import { useI18n } from "vue-i18n";
import "./App.css";
import * as uni from "./utils/uni.webview.1.5.4.js";

const { t, locale } = useI18n();
const isMobile = !TUIGlobal.isPC;
const SDKAppID = ref<number>(0);
const SecretKey = ref<string>("");
const userID = ref<string>("");
const loginUserID = ref<string>("");
const userList = ref<string[]>([]);
const currentUserID = ref<string>("");
const isLogin = ref<boolean>(false);
const userSig = ref<string>("");
const formImId = ref<string>("");
const isNewTab = ref<boolean>(false);
const isMinimized = ref<boolean>(false);
const finishedRTCDetectStatus = ref<string>("");
const isSkippedRTCDetect = ref<boolean>(false);
const isLoadCalling = ref<boolean>(false);

const typeString = ref<string>("video");
const isCalling = ref<boolean>(false);
const groupID = ref<string>("");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let loadingInstance: any = null;
let ws: any = null;
// 测试环境
//const websocketUrl = "wss://rehabilitation.wss.test.dph.cn/websocket";
// 正式环境
const websocketUrl = "wss://rehabilitation.wss.dph.cn/websocket";
// 本地开发环境
// const websocketUrl = "ws://192.168.1.43:19999/websocket";
// websocket心跳间隔（毫秒）
const WEBSOCKET_HEART_BEAT_INTERVAL = 20000;
let heartbeatInterval: any = null; //检测服务器端是否还活着
let reconnectTimeOut: any = null; //重连之后多久再次重连
let isOpenSocket = false; //避免重复连接
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let tim: any = null;

onMounted(() => {
    if (isWeixin() || isMobile) {
        loadingInstance = ElLoading.service({ fullscreen: true });
    }
    const sdkAppID = getUrlParam("SDKAppID");
    if (!sdkAppID) SDKAppID.value = 0;
    else {
        SDKAppID.value = parseInt(sdkAppID as string);
        isNewTab.value = true;
    }
    userSig.value = getUrlParam("userSig") || "";
    formImId.value = getUrlParam("formImId") || "";
    loginUserID.value = getUrlParam("userID") || "";
    initWebSocket();
    console.log("loginUserID.value==", loginUserID.value);
    console.log("userSig.value==", userSig.value);
    console.log("SDKAppID.value==", SDKAppID.value);
    if (SDKAppID.value && userSig.value && loginUserID.value) {
        autoLogin();
    }
    TUICallKitServer.setLanguage(locale.value);
    finishedRTCDetectStatus.value =
        localStorage.getItem("callkit-basic-demo-finish-rtc-detect") || "";
});

onUnmounted(() => {
    if (isLogin.value) {
        handleDestroy();
    }
});

async function autoLogin() {
    if (!SDKAppID.value || SDKAppID.value === 0) {
        ElMessage.error(t("input-SDKAppID"));
        return;
    }
    if (!userSig.value) {
        ElMessage.error(t("input-SecretKey"));
        return;
    }
    if (!loginUserID.value) {
        ElMessage.error(t("input-userID"));
        return;
    }
    console.log("tim==", tim);
    if (!isLogin.value) {
        tim = TIM.create({
            SDKAppID: SDKAppID.value,
        });
        await TUICallKitServer.init({
            userID: loginUserID.value,
            userSig: userSig.value,
            SDKAppID: Number(SDKAppID.value),
            tim,
        });
        currentUserID.value = loginUserID.value;
        isLogin.value = true;
        // 通知医生端SDK初始化成功
        sendTuiCallKitInitMessage();
        // if (
        //     finishedRTCDetectStatus.value !== "finished" &&
        //     finishedRTCDetectStatus.value !== "skiped"
        // )
        //     initNetWorkInfo();
    } else {
        // 通知医生端SDK初始化成功
        sendTuiCallKitInitMessage();
    }
}

async function login() {
    if (!SDKAppID.value || SDKAppID.value === 0) {
        ElMessage.error(t("input-SDKAppID"));
        return;
    }
    tim = TIM.create({
        SDKAppID: SDKAppID.value,
    });
    try {
        await TUICallKitServer.init({
            userID: loginUserID.value,
            userSig: userSig.value,
            SDKAppID: Number(SDKAppID.value),
            tim,
        });
        currentUserID.value = loginUserID.value;
        isLogin.value = true;
        if (
            finishedRTCDetectStatus.value !== "finished" &&
            finishedRTCDetectStatus.value !== "skiped"
        )
            initNetWorkInfo();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        if (error.message)
            ElMessage.error(`${t("login-failed-message")} ${error.message}`);
    }
}

function initWebSocket() {
    ws = new WebSocket(websocketUrl);
    ws.onopen = () => {
        console.log("Websocket  WebSocket连接正常！");
        if (reconnectTimeOut) {
            clearTimeout(reconnectTimeOut);
        }
        if (heartbeatInterval) {
            clearTimeout(heartbeatInterval);
        }
        isOpenSocket = true;
        send({ type: "REGISTER", userId: `${loginUserID.value}-trtc` });
        start();
    };
    ws.onmessage = (event) => {
        console.log("Websocket message received.", event.data);
    };
    ws.onerror = (error) => {
        console.error("Websocket error occurred.", error);
    };
    ws.onclose = () => {
        console.log("Websocket 已经被关闭了");
        isOpenSocket = false;
        reconnect();
    };
}

//重新连接
function reconnect() {
    //停止发送心跳
    clearInterval(heartbeatInterval);
    //如果不是人为关闭的话，进行重连
    if (!isOpenSocket) {
        reconnectTimeOut = setTimeout(() => {
            initWebSocket();
        }, 3000);
    }
}

//开启心跳检测
function start() {
    console.log("开启心跳检测2222222");
    heartbeatInterval = setInterval(() => {
        let data = {
            type: "HEARTBEAT",
            userId: `${loginUserID.value}-trtc`,
        };
        send(data);
    }, WEBSOCKET_HEART_BEAT_INTERVAL);
}

function send(data) {
    if (ws.readyState === WebSocket.OPEN) {
        console.log("send===", data);
        ws.send(JSON.stringify(data));
    } else {
        console.error("Websocket connection not open.");
    }
}

function sendTuiCallKitInitMessage() {
    let data = {
        type: "TEXT",
        toUserId: formImId.value,
        clientTimeStamp: Date.now(),
        messageCode: 3000,
        userId: `${loginUserID.value}-trtc`,
    };
    send(data);
}

function closeWebSocket() {
    if (ws) {
        ws.close();
    }
}

function handleDestroy() {
    TUICallKitServer.destroyed();
    logout();
    closeWebSocket();
    isLogin.value = false;
}

function switchCallType(type: string) {
    if (isCalling.value) return;
    typeString.value = type;
}

async function startCall(typeString: string) {
    if (!isLogin.value) {
        ElMessage.error(t("not-login"));
        return;
    }
    const type = typeString === "audio" ? 1 : 2;
    if (userList.value.length <= 0) {
        ElMessage.error(t("calling-list-is-empty"));
        return;
    }
    const callType = userList.value.length === 1 ? "call" : "groupCall";
    isLoadCalling.value = true;
    try {
        isCalling.value = true;
        if (callType === "call")
            await TUICallKitServer.call({ userID: userList.value[0], type });
        else {
            // you can use existing groups, no need to create a new group every time
            groupID.value = await createGroup();
            await TUICallKitServer.groupCall({
                userIDList: userList.value,
                type,
                groupID: groupID.value,
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        isCalling.value = false;
        console.error("startCall", error);
        if (error.message) ElMessage.error(error.message);
    }
    isLoadCalling.value = false;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function beforeCalling(type: string, error: any) {
    console.log("basic demo beforeCalling", type, error);
    if (!error) isCalling.value = true;
    else {
        console.error("basic demo beforeCalling", error);
        ElMessage.error(`${error.type}: ${error.message}`);
    }
}

function afterCalling() {
    userList.value = [];
    isCalling.value = false;
    isMinimized.value = false;
    console.log("handleStatusChanged:", jweixin.miniProgram);
    if (isWeixin()) {
        console.log("navigateBack: isWeixin");
        jweixin.miniProgram.navigateBack();
    }else{
        uni.webView.navigateBack();
    }
}

function onMinimized(oldStatus: boolean, newStatus: boolean) {
    console.log("onMinimized: " + oldStatus + " -> " + newStatus);
    if (newStatus === true) {
        isMinimized.value = true;
    } else {
        isMinimized.value = false;
    }
}

function addUser(userIDParam: string) {
    if (!userIDParam) return;
    let index = userList.value.indexOf(userIDParam);
    index < 0 && userList.value.push(userIDParam);
    userID.value = "";
}

function removeUser(userID: string) {
    let index = userList.value.indexOf(userID);
    index > -1 && userList.value.splice(index, 1);
}

async function createGroup() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const memberList: any[] = [];
    userList.value.forEach((user: string) => {
        memberList.push({ userID: user });
    });
    let res = await tim.createGroup({
        type: TIM.TYPES.GRP_PUBLIC,
        name: "group-call",
        memberList,
    });
    return res.data.group.groupID;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function newTab(event: any) {
    event.stopPropagation();
    window.open(
        `/?SDKAppID=${SDKAppID.value}&SecretKey=${SecretKey.value}`,
        "_blank"
    );
}

function copyUserID() {
    const isSuccessCopy = copy(currentUserID.value);
    if (isSuccessCopy) {
        ElMessage.success(t("copied"));
    } else {
        ElMessage.warning(t("copy-failed-message"));
    }
}

function handleClose() {
    showDeviceDetector.value = false;
    isSkippedRTCDetect.value = true;
    ElMessage.warning(t("skip-device-detector"));
    localStorage.setItem("callkit-basic-demo-finish-rtc-detect", "skiped");
}

function handleFinishDetect() {
    showDeviceDetector.value = false;
    finishedRTCDetectStatus.value = "finished";
    localStorage.setItem("callkit-basic-demo-finish-rtc-detect", "finished");
}

const networkDetectInfo = ref();
const showDeviceDetector = ref<boolean>(false);

const initNetWorkInfo = async () => {
    console.log("initNetWorkInfo");
    if (!SDKAppID.value || !SecretKey.value) {
        ElMessage.error(t("please-input-param"));
        return;
    }
    const status = localStorage.getItem("callkit-basic-demo-finish-rtc-detect");
    if (status === "finished") return;
    const uplinkUserId = currentUserID.value + "_uplink_test";
    const downlinkUserId = currentUserID.value + "_downlink_test";
    const roomId = 999999;
    showDeviceDetector.value = true;
};

function switchLanguage() {
    switch (locale.value) {
        case "zh-cn":
            locale.value = "en";
            localStorage.setItem("basic-demo-language", "en");
            TUICallKitServer.setLanguage("en");
            break;
        case "en":
        default:
            locale.value = "zh-cn";
            localStorage.setItem("basic-demo-language", "zh-cn");
            TUICallKitServer.setLanguage("zh-cn");
            break;
    }
}

async function logout() {
    await TUICallKitServer.destroyed();
    tim.logout();
    isLogin.value = false;
}

function handleKickedOut() {
    console.log("The user has been kicked out");
    isLogin.value = false;
}

let TUICallKitStatus: string = STATUS.IDLE;
function handleStatusChanged(args: { oldStatus: string; newStatus: string }) {
    const { oldStatus, newStatus } = args;
    console.log("Call status changes: " + oldStatus + " -> " + newStatus);
    TUICallKitStatus = newStatus;
    if (newStatus === STATUS.IDLE) {

    } else {
        nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            if (loadingInstance) {
                loadingInstance.close();
            }
        });
    }
}

async function accept() {
    try {
        if (TUICallKitStatus === STATUS.BE_INVITED) {
            await TUICallKitServer.accept();
            ElMessage.warning("Answered automatically");
        }
    } catch (error: any) {
        alert(`Automatic answering failed, reason: ${error}`);
    }
}

async function reject() {
    try {
        if (TUICallKitStatus === STATUS.BE_INVITED) {
            await TUICallKitServer.reject();
            ElMessage.warning("Automatically rejected");
        }
    } catch (error: any) {
        alert(`Automatic rejection failed due to: ${error}`);
    }
}

async function hangup() {
    try {
        if (
            TUICallKitStatus === STATUS.CALLING_C2C_AUDIO ||
            TUICallKitStatus === STATUS.CALLING_C2C_VIDEO ||
            TUICallKitStatus === STATUS.CALLING_GROUP_AUDIO ||
            TUICallKitStatus === STATUS.CALLING_GROUP_VIDEO
        ) {
            await TUICallKitServer.hangup();
            ElMessage.warning("Automatically hung up");
        }
    } catch (error: any) {
        alert(`Automatic hang-up failed, reason: ${error}`);
    }
}
</script>

<template>
    <div class="wrapper">
        <DeviceDetector
            :visible="showDeviceDetector"
            :onClose="handleClose"
            :onFinish="handleFinishDetect"
            :networkDetectInfo="networkDetectInfo"
        >
        </DeviceDetector>
        <div
            v-if="!isCalling && !isWeixin()"
            style="display: flex; align-items: center"
        >
            <div class="switch">
                <div
                    class="switch-btn"
                    :class="typeString === 'video' ? 'switch-select' : ''"
                    :style="
                        isCalling ? 'cursor: not-allowed' : 'cursor: pointer'
                    "
                    @click="switchCallType('video')"
                >
                    <img
                        :src="
                            typeString === 'video'
                                ? videoWhiteSVG
                                : videoBlackSVG
                        "
                        class="icon"
                    />
                    <span class="switch-name"> {{ t("video-call") }} </span>
                </div>
                <div
                    class="switch-btn"
                    :class="typeString === 'audio' ? 'switch-select' : ''"
                    :style="
                        isCalling ? 'cursor: not-allowed' : 'cursor: pointer'
                    "
                    @click="switchCallType('audio')"
                >
                    <img
                        :src="
                            typeString === 'audio'
                                ? audioWhiteSVG
                                : audioBlackSVG
                        "
                        class="icon"
                    />
                    <span class="switch-name"> {{ t("voice-call") }} </span>
                </div>
            </div>
        </div>
        <div
            :class="isMobile ? 'switch-language-H5' : 'switch-language'"
            v-if="!isWeixin() && !isMobile"
            @click="switchLanguage()"
        >
            <img :src="languageSVG" class="icon" />
            <div class="language-name">
                {{ locale == "en" ? "简体中文" : "English" }}
            </div>
        </div>
        <div :class="isMobile ? 'call-kit-container-H5' : 'call-kit-container'">
            <div
                class="search"
                v-show="!isWeixin() && !isMobile && (!isCalling || isMinimized)"
            >
                <div class="search-window search-left">
                    <div class="search-title">
                        {{
                            typeString === "video"
                                ? t("video-call")
                                : t("voice-call")
                        }}
                        <span
                            v-if="isLogin"
                            class="user-id"
                            @click="copyUserID"
                        >
                            userID: {{ currentUserID }}
                            <button
                                @click="(event) => newTab(event)"
                                v-if="!isNewTab"
                            >
                                {{ t("login-other") }} UserID
                                <svg width="14" height="14" viewBox="0 0 16 16">
                                    <path
                                        fill="currentColor"
                                        fill-rule="evenodd"
                                        d="M10.75 1a.75.75 0 0 0 0 1.5h1.69L8.22 6.72a.75.75 0 0 0 1.06 1.06l4.22-4.22v1.69a.75.75 0 0 0 1.5 0V1h-4.25ZM2.5 4v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V8.75a.75.75 0 0 1 1.5 0V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4.25a.75.75 0 0 1 0 1.5H3a.5.5 0 0 0-.5.5Z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </button>
                            <span v-else>
                                <svg width="14" height="14" viewBox="0 0 24 24">
                                    <g fill="none">
                                        <path d="M0 0h24v24H0z" />
                                        <path
                                            fill="currentColor"
                                            d="M19 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2V4a2 2 0 0 1 2-2h10Zm-4 6H5v12h10V8Zm-5 7a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h2Zm9-11H9v2h6a2 2 0 0 1 2 2v8h2V4Zm-7 7a1 1 0 0 1 .117 1.993L12 13H8a1 1 0 0 1-.117-1.993L8 11h4Z"
                                        />
                                    </g>
                                </svg>
                            </span>
                            <button @click.stop="logout()">
                                {{ t("logout") }}
                            </button>
                        </span>
                    </div>
                    <div class="search-input-container">
                        <img :src="searchSVG" class="icon-search" />
                        <input
                            class="search-input"
                            type="text"
                            v-model="userID"
                        />
                    </div>
                    <div class="add-btn" @click="addUser(userID)">
                        {{ t("add-to-calling-list") }}
                    </div>
                </div>
                <div class="search-window search-right">
                    <div class="selected-title">{{ t("calling-list") }}</div>
                    <div class="search-results">
                        <div
                            class="result-item"
                            v-for="item in userList"
                            v-bind:key="item"
                        >
                            <div class="user-item">
                                <div class="userID">{{ item }}</div>
                                <div class="user-email">{{ item }}</div>
                            </div>
                            <img
                                :src="cancelSVG"
                                class="checkbox cancel"
                                @click="removeUser(item)"
                            />
                        </div>
                    </div>
                    <div class="call-buttons">
                        <div
                            class="rtc-detector-starter"
                            @click="initNetWorkInfo()"
                            v-show="isLogin"
                        >
                            {{ t("start-to-detector") }}
                        </div>
                        <div
                            :class="
                                !isLoadCalling ? 'call-btn' : 'call-btn-gray'
                            "
                            @click="startCall(typeString)"
                            :disabled="isLoadCalling"
                        >
                            <img
                                v-show="isLoadCalling"
                                src="./assets/loading.png"
                                class="loading-img"
                            />
                            {{ t("call") }}
                        </div>
                    </div>
                </div>
            </div>
            <TUICallKit
                :beforeCalling="beforeCalling"
                :afterCalling="afterCalling"
                :onMinimized="onMinimized"
                :allowedMinimized="true"
                :allowedFullScreen="true"
                :kickedOut="handleKickedOut"
                :statusChanged="handleStatusChanged"
            />
        </div>
        <div id="debug" v-show="!isWeixin() && !isMobile && false">
            <div>
                <b>Debug Panel</b>
            </div>
            <span>UserID: </span>
            <input v-model="loginUserID" placeholder="UserID" />
            <br />
            <button @click="login()">{{ t("login") }}</button>
        </div>
    </div>
</template>
